import React from "react";
import { Grid, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import useTotals from "../hooks/useTotals";
import { useLocation } from "react-router-dom";

function renderTextField(label, value) {
  return (
    <Grid item xs={12} key={label}>
      <TextField
        label={label}
        size="small"
        variant="standard"
        style={{ width: "100%" }}
        value={`$${(value).toLocaleString()}`}
        InputProps={{ readOnly: true }}
      />
    </Grid>
  );
}

export default function OrderTotals({ dynamicsId, totalDesc, item, order }) {
  const { items, webOrderId } = useSelector((state) => order ? state.order : state.cart )
  const { subtotal, discount, tax, total } = useTotals(items, dynamicsId, totalDesc)

  let fieldsTotals;
  if (item && webOrderId !== null) {
    const { subtotal, discount, tax, total } = item;
    fieldsTotals = [
      renderTextField("Subtotal", subtotal),
      renderTextField("Descuento Comercial", discount),
      renderTextField("Impuestos", tax),
      renderTextField("Total", total),
    ];

  } else {
    fieldsTotals = [
      renderTextField("Subtotal", subtotal),
      renderTextField("Descuento Comercial", discount),
      renderTextField("Impuestos", tax),
      renderTextField("Total", total),
    ];

  }


  return (
    <Grid container spacing={2}>
      {fieldsTotals}
    </Grid>
  );
}
